var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0007 7.28576C9.23008 7.28576 8.67416 7.90032 8.67416 8.57147C8.67416 9.24262 9.23008 9.85719 10.0007 9.85719C10.7713 9.85719 11.3272 9.24262 11.3272 8.57147C11.3272 7.90032 10.7713 7.28576 10.0007 7.28576ZM7.0415 8.57147C7.0415 6.87569 8.40437 5.57147 10.0007 5.57147C11.597 5.57147 12.9599 6.87569 12.9599 8.57147C12.9599 10.2673 11.597 11.5715 10.0007 11.5715C8.40437 11.5715 7.0415 10.2673 7.0415 8.57147Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39723 3.91013C6.62468 2.68269 8.2813 2 10.0008 2C11.7204 2 13.377 2.68269 14.6044 3.91013C15.8332 5.13892 16.5314 6.81471 16.5314 8.57143C16.5314 9.31099 16.4529 9.97122 16.2445 10.6001C16.0349 11.2323 15.7091 11.7875 15.2683 12.3376C15.2615 12.3461 15.2545 12.3544 15.2474 12.3626L10.6046 17.7197C10.4499 17.8983 10.2307 18 10.0008 18C9.77097 18 9.55177 17.8983 9.39707 17.7197L4.75421 12.3626C4.74711 12.3544 4.74017 12.3461 4.73338 12.3376C4.29252 11.7875 3.96672 11.2323 3.75718 10.6001C3.54871 9.97122 3.47021 9.31099 3.47021 8.57143C3.47021 6.81471 4.16844 5.13892 5.39723 3.91013ZM10.0008 3.71429C8.68931 3.71429 7.43903 4.23568 6.5232 5.15151C5.60872 6.06599 5.10287 7.2971 5.10287 8.57143C5.10287 9.1833 5.16794 9.64092 5.29911 10.0366C5.42797 10.4254 5.63511 10.7981 5.97271 11.2215L10.0008 15.8693L14.0289 11.2215C14.3665 10.7981 14.5737 10.4254 14.7025 10.0366C14.8337 9.64092 14.8988 9.1833 14.8988 8.57143C14.8988 7.2971 14.3929 6.06599 13.4785 5.15151C12.5626 4.23568 11.3123 3.71429 10.0008 3.71429Z",
    fill: "white",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.7eb69fade08367abb8d11fab9cd9c56b.svg";
export { ForwardRef as ReactComponent };